import '@fontsource/roboto' // Defaults to weight 400 with all styles included.
import '@fontsource/roboto/700.css'
import '@fontsource/roboto/900.css'

import React from 'react'
import GlobalContextProvider from './src/store'

export const wrapRootElement = ({ element }) => <GlobalContextProvider>{element}</GlobalContextProvider>
